import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheveron = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 12.6L7.4 8L6 9.4L12 15.4L18 9.4L16.6 8L12 12.6Z", fill: "#002244" }));
const ForwardRef = forwardRef(SvgIconCheveron);
export default ForwardRef;
